module.exports = __webpack_public_path__ + "static/media/CT_2019_30445_1598A_pdf.e2bbe824.pdf";